var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 53,
    viewBox: "0 0 90 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e,.f{fill:#fff;}.a{stroke:#dadada;}.a,.b{stroke-miterlimit:10;}.b{fill:rgba(0,114,198,0.05);}.b,.d,.e{stroke:#0072c6;}.c,.h{fill:none;}.c{stroke:#d3d3d3;}.d{fill:#0072c6;}.d,.e{stroke-width:2px;}.f{stroke:#c4c4c4;stroke-width:0.5px;}.g{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16435 24425)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-16435 -24425)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 90,
    height: 53,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.5,
    y: 0.5,
    width: 89,
    height: 52,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-16434 -24425)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 89,
    height: 53,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 52,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.649)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 70,
    transform: "translate(-16426.887 -24415.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-16427.648 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.008,
    cy: 3.008,
    r: 3.008
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.008,
    cy: 3.008,
    r: 2.008
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-16395.855 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-16413.398 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-16377.941 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(-16360.941 -24419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 3.14,
    cy: 3.14,
    r: 3.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 3.14,
    cy: 3.14,
    r: 2.14
  }))), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(-16427 -24408)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 75,
    height: 31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.25,
    y: 0.25,
    width: 74.5,
    height: 30.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle1);
export default __webpack_public_path__ + "static/media/style1.ad7a422d5d1970c3a0c5c2ca39dd64ad.svg";
export { ForwardRef as ReactComponent };